import type { SelectHTMLAttributes } from 'react';

interface SelectOption {
  readonly value: string;
  readonly label: string;
}

interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  readonly label: string;
  readonly options: readonly SelectOption[];
  readonly placeholder?: string;
}

export const Select = ({
  label,
  options,
  placeholder,
  id,
  className = '',
  style,
  ...props
}: SelectProps) => {
  return (
    <div>
      <label
        htmlFor={id}
        style={{
          display: 'block',
          fontSize: 'var(--text-sm)',
          fontWeight: 'var(--font-weight-medium)',
          color: 'var(--text-secondary)',
        }}
      >
        {label}
      </label>
      <select
        id={id}
        className={`focus-ring ${className}`}
        style={{
          marginTop: 'var(--space-1)',
          display: 'block',
          width: '100%',
          borderRadius: 'var(--radius-md)',
          border: '1px solid var(--border-default)',
          padding: 'var(--space-2) var(--space-3)',
          fontSize: 'var(--text-base)',
          backgroundColor: 'var(--bg-surface)',
          color: 'var(--text-primary)',
          outline: 'none',
          transition: `border-color var(--duration-fast) var(--ease-out)`,
          ...style,
        }}
        onFocus={(e) => { e.currentTarget.style.borderColor = 'var(--border-focus)'; }}
        onBlur={(e) => { e.currentTarget.style.borderColor = 'var(--border-default)'; }}
        {...props}
      >
        {placeholder && (
          <option value="">{placeholder}</option>
        )}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
    </div>
  );
};
